import React from 'react'
import Dropdown from 'react-dropdown';
import './hero-dropdown.css';
import { ChevronDown } from 'react-feather'
import { useSystem } from '../../../features/system/hook';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { setSelectedAudience } from '../../../features/system/slice';

const RoleDropdown = ({
  layoutClass = `items-center justify-center`,
}) => {
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()

  const {
    uppercasedAudienceOptions,
    uppercasedAudienceOptionsMap,
  } = useSystem()
  const uppercased = uppercasedAudienceOptions
  const finalOptions = uppercased

  const selectedAudience = useSelector(state => state.system.selectedAudience)
  const { audiencesById, language, selectedAudienceId } = useSelector(state => state.system)
  const [show, setShow] = React.useState(true)
  const currentParams = new URLSearchParams(location.search)
  const currentId = currentParams.get('audience')

  React.useEffect(() => {
    if(currentId !== selectedAudienceId){
      setShow(false)

      if(parseInt(currentId) === 1 || currentId === null){
        dispatch(setSelectedAudience({label: 'SEMUA ORANG', value: 'SEMUA ORANG', id: 1}))
      } else {
        const obj = audiencesById[currentId]
        if(obj && obj.name && obj.name[language.name]){
          const name = obj.name[language.name].toUpperCase()
          dispatch(setSelectedAudience({label: name, value: name, id: parseInt(currentId)}))
        }
      }

      setTimeout(() => setShow(true), 100)
    }
    //eslint-disable-next-line
  }, [currentId, selectedAudienceId])

  const handleChange = (e) => {
    const newId = uppercasedAudienceOptionsMap[e.value].id
    const newSelectedAudience = {
      ...e,
      id: newId
    }
    dispatch(setSelectedAudience(newSelectedAudience))

    if(currentId !== newId){
      let newRoute = location.pathname

      // Ignore "Semua Orang"
      if(newId === 1){
        currentParams.delete('audience')
      } else {
        currentParams.set('audience', newId)
      }

      history.push(newRoute+'?'+currentParams.toString())
    }
  }

  return (
    <div className={`${layoutClass} flex relative`}>
      <div className="flex items-center cursor-pointer">
        <ChevronDown
          style={{width: '16px', height: '16px', color: '#52BAE2'}}
          className="mr-2"
        />

        {
          show &&
          <Dropdown
            options={finalOptions}
            onChange={handleChange}
            value={selectedAudience}
            placeholder="Select an option"
            className="hero-role-dropdown"
          />
        }
      </div>
    </div>
  )
}

export { RoleDropdown }

// Backup

// const options = [
//   'FOR EVERYONE',
//   'FOR PRACTITIONER', 'FOR EDUCATOR',
//   'FOR POLICY MAKER',
//   'FOR RESEARCHER', 'FOR DONOR'
// ];
